<div class="content pointer-events-none" [style]="mergedCss">
  <iframe
    title="i-frame"
    [cachedSrc]="iframeUrl"
    width="100%"
    [style]="{ height: iframeHeight }"
    sandbox="allow-scripts allow-same-origin"
    referrerpolicy="no-referrer"
  ></iframe>
</div>
